<template>
  <div class="course-place is-station text-btn_secondary">
    <div class="station-tab">
      <span>{{ label }}</span>
    </div>
    <div class="station-info">
      <div class="course-time text-right font-bold">
        <p class="single">
          {{ time }}
        </p>
      </div>
      <div class="course-place-info-number w-6 h-6 ml-1 text-center border font-bold text-white flex-shrink-0">
        {{ routeIndex + 1 }}
      </div>
      <div class="plan-icon ml-1 mr-1">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 0H2C0.89543 0 0 0.89543 0 2V22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.89543 23.1046 0 22 0Z"/>
        <path d="M8.73054 20.5778L10.4491 18.8174H13.7605L15.479 20.5778H17.2395V20.1377L15.9401 18.8174C16.485 18.8174 16.995 18.6811 17.4701 18.4087C17.9451 18.1362 18.3189 17.7695 18.5913 17.3084C18.8638 16.8473 19 16.3373 19 15.7784V7.47904C19 6.501 18.6786 5.74651 18.0359 5.21557C17.477 4.74052 16.6387 4.40519 15.521 4.20958C14.6547 4.06986 13.481 4 12 4C10.6307 4 9.51297 4.06986 8.64671 4.20958C7.501 4.40519 6.63473 4.74052 6.0479 5.21557C5.3493 5.76048 5 6.51497 5 7.47904V15.7784C5 16.3373 5.13972 16.8473 5.41916 17.3084C5.6986 17.7695 6.07236 18.1362 6.54042 18.4087C7.00848 18.6811 7.52196 18.8174 8.08084 18.8174L6.76048 20.1377V20.5778H8.73054ZM17.2395 10.9581H12.8593V7.47904H17.2395V10.9581ZM11.1407 10.9581H6.76048V7.47904H11.1407V10.9581ZM15.9401 17.0988C15.5629 17.0988 15.2485 16.9696 14.997 16.7111C14.7455 16.4526 14.6198 16.1417 14.6198 15.7784C14.6198 15.4152 14.749 15.1078 15.0075 14.8563C15.266 14.6048 15.5768 14.479 15.9401 14.479C16.3034 14.479 16.6108 14.6013 16.8623 14.8458C17.1138 15.0903 17.2395 15.4012 17.2395 15.7784C17.2395 16.1557 17.1138 16.4701 16.8623 16.7216C16.6108 16.9731 16.3034 17.0988 15.9401 17.0988V17.0988ZM8.08084 17.0988C7.70359 17.0988 7.38922 16.9696 7.13772 16.7111C6.88623 16.4526 6.76048 16.1417 6.76048 15.7784C6.76048 15.4152 6.88972 15.1078 7.1482 14.8563C7.40669 14.6048 7.71756 14.479 8.08084 14.479C8.44411 14.479 8.7515 14.6013 9.00299 14.8458C9.25449 15.0903 9.38024 15.4012 9.38024 15.7784C9.38024 16.1557 9.25449 16.4701 9.00299 16.7216C8.7515 16.9731 8.44411 17.0988 8.08084 17.0988V17.0988Z" fill="white"/>
        </svg>
      </div>
      <div class="course-name text-lg leading-5 text-body font-bold break-all">
        {{ station.name }}
      </div>
      <div class="plan-icon ml-1 mr-2">
        <a @click="showMap">
          <img src="@/assets/images/icon-plan-map.svg" :alt="$t('tour_map_label')" />
        </a>
      </div>
    </div>
    <div v-if="editable" class="self-start">
      <div class="button-edit-is-arrival text-link">
        <place-button :action="showDepartureModal" :name="buttonLabel" />
      </div>
    </div>
  </div>
</template>

<script>
import PlaceButton from "../atoms/PlaceButton"
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    PlaceButton
  },
  props: {
    station: {
      type: Object,
      required: true
    },
    showDepartureModal: {
      type: Function,
      required: true
    },
    editable: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    isDeparture: {
      type: Boolean,
      default: function () {
        return true
      }
    },
    route: {
      type: Object,
      default: function () {
        return {
          departureTime: moment(),
          arrivalTime: moment()
        }
      }
    },
    routeIndex: {
      type: Number,
      required: true
    }
  },
  methods: {
    showMap: function () {
      const location = this.station.location
      const params = {
        lat: location.latitude,
        lng: location.longitude
      }
      this.$store.dispatch('map/updateCenter', params)
      this.$router.push({ name: 'map', params: { lang: this.$store.getters['user/getLang'] } })
    }
  },
  computed: {
    label: function () {
      return this.isDeparture ? this.$t('tour_departure_label') : this.$t('tour_arrival_label')
    },
    buttonLabel: function () {
      return this.isDeparture ? this.$t('tour_change_departure_label') : this.$t('tour_change_arrival_label')
    },
    time: function () {
      const t = this.isDeparture ? this.route.departureTime : this.route.arrivalTime
      return t.format("HH:mm")
    }
  }
}
</script>
